module.exports = __webpack_public_path__ + "img/SWP_Sword_2H_04.82fbe3b6.png";